module.exports = __webpack_public_path__ + "img/pina_colada.d28fd38b.jpg";